import { request } from '../util'

const url = '/private/api/module-permissions'

export default {
  list () {
    return request(url)
  }
}
